/**
 * @generated SignedSource<<259ac570f900408f8bd6e543cedddd4e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoCategoryScreenTodoUpadateSubscription$variables = {
  categoryId: string;
  teamId: string;
};
export type TodoCategoryScreenTodoUpadateSubscription$data = {
  readonly todoChanged: {
    readonly ordinal: string;
    readonly " $fragmentSpreads": FragmentRefs<"TodoListItem_todo">;
  } | null;
};
export type TodoCategoryScreenTodoUpadateSubscription = {
  response: TodoCategoryScreenTodoUpadateSubscription$data;
  variables: TodoCategoryScreenTodoUpadateSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "categoryId",
    "variableName": "categoryId"
  },
  {
    "items": [
      {
        "kind": "Variable",
        "name": "teamIds.0",
        "variableName": "teamId"
      }
    ],
    "kind": "ListValue",
    "name": "teamIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordinal",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "thumbhash",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageSize",
    "kind": "LinkedField",
    "name": "sizes",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlExpiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkedToViewer",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workStatus",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPublicAndInternalImage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicImageUrl",
          "storageKey": null
        }
      ],
      "type": "PublicImage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v6/*: any*/),
      "type": "Image",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v14 = [
  (v3/*: any*/),
  (v9/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/)
],
v15 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "style",
      "value": "DEFAULT"
    }
  ],
  "kind": "ScalarField",
  "name": "storeFormattedDate",
  "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
},
v16 = [
  (v15/*: any*/)
],
v17 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isActor"
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v13/*: any*/),
    (v12/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v19 = [
  (v9/*: any*/),
  (v3/*: any*/)
],
v20 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StorecastScreen",
      "kind": "LinkedField",
      "name": "screen",
      "plural": false,
      "selections": (v19/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ScreenActor",
  "abstractKey": null
},
v21 = [
  (v18/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifyingName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoCategoryScreenTodoUpadateSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoChanged",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TodoListItem_todo"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoCategoryScreenTodoUpadateSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoChanged",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "response",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/)
                ],
                "type": "TodoResponseImage",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canWrite",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isOrg",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formattedBody",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canChangeStatus",
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isIssue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priority",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoContact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phoneNumber",
                "storageKey": null
              },
              (v10/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "feedbackStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AssignedEmployee",
            "kind": "LinkedField",
            "name": "assigned",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "assignedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Employee",
                "kind": "LinkedField",
                "name": "employee",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              (v3/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AssignedRole",
            "kind": "LinkedField",
            "name": "assignedRoles",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EmployeeRole",
                "kind": "LinkedField",
                "name": "role",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v9/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "employeeIds",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Employee",
                    "kind": "LinkedField",
                    "name": "employees",
                    "plural": true,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "expireAtDate",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isoString",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategoryTag",
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreProduct",
            "kind": "LinkedField",
            "name": "linkedProducts",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "subTodos",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "commentCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expireAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isResponseCompleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "resolvedAtDate",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "lastChangedStatusByActor",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v17/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreUser",
                    "kind": "LinkedField",
                    "name": "storeUser",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "UserActor",
                "abstractKey": null
              },
              (v20/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v21/*: any*/),
                "type": "GroupActor",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v21/*: any*/),
                "type": "ConnectActor",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "createdAtDate",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeToResolvedFormatted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoSubject",
            "kind": "LinkedField",
            "name": "subject",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoSubjectBreadcrumb",
                "kind": "LinkedField",
                "name": "allBreadcrumbs",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requiredToDescribeTodo",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iconUri",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "createdByActor",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v17/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreUser",
                    "kind": "LinkedField",
                    "name": "storeUser",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrgDescription",
                            "kind": "LinkedField",
                            "name": "orgDescription",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "orgIconUri",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "UserActor",
                "abstractKey": null
              },
              (v20/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Employee",
                    "kind": "LinkedField",
                    "name": "employee",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v3/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "GroupActor",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v23/*: any*/),
                  (v22/*: any*/)
                ],
                "type": "ConnectActor",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "80717c3dddc43b24f5a134d889effd1c",
    "id": null,
    "metadata": {},
    "name": "TodoCategoryScreenTodoUpadateSubscription",
    "operationKind": "subscription",
    "text": "subscription TodoCategoryScreenTodoUpadateSubscription(\n  $categoryId: ID!\n  $teamId: ID!\n) {\n  todoChanged(teamIds: [$teamId], categoryId: $categoryId) {\n    ordinal\n    ...TodoListItem_todo\n    id\n  }\n}\n\nfragment Avatar_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        ...Avatar_employee\n        id\n      }\n      user {\n        name\n        ...Avatar_user\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    ...Avatar_groupActor\n  }\n  ... on ConnectActor {\n    __typename\n    ...Avatar_connectActor\n  }\n}\n\nfragment Avatar_connectActor on ConnectActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_employee on Employee {\n  image {\n    __typename\n    ...ImagePublicOrPrivate_image\n    ... on Image {\n      id\n    }\n  }\n  workStatus\n  name\n}\n\nfragment Avatar_groupActor on GroupActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_user on User {\n  name\n}\n\nfragment CreatedBySubject_actor on Actor {\n  __isActor: __typename\n  ...SignedActorCompact_actor\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment ListItemAssignees_employees on Employee {\n  id\n  ...ListItemEmployees_employees\n}\n\nfragment ListItemAssignees_roles on EmployeeRole {\n  id\n  ...ListItemRoles_roles\n}\n\nfragment ListItemEmployees_employees on Employee {\n  id\n  name\n  isLinkedToViewer\n  workStatus\n  ...Avatar_employee\n}\n\nfragment ListItemRoles_roles on EmployeeRole {\n  id\n  name\n  isLinkedToViewer\n  employeeIds\n  team {\n    id\n  }\n  employees {\n    id\n    name\n    isLinkedToViewer\n    workStatus\n    ...Avatar_employee\n  }\n}\n\nfragment SignedActorCompactBadge_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    storeUser {\n      user {\n        orgDescription {\n          orgIconUri\n        }\n        id\n      }\n      id\n    }\n    __typename\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      __typename\n      id\n    }\n    user {\n      __typename\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n  }\n  ... on ConnectActor {\n    __typename\n  }\n}\n\nfragment SignedActorCompact_actor on Actor {\n  __isActor: __typename\n  ...SignedActorText_actor\n  ...SignedActorCompactBadge_actor\n}\n\nfragment SignedActorText_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        id\n      }\n      user {\n        name\n        email\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      name\n      id\n    }\n    identifyingName\n  }\n  ... on ConnectActor {\n    __typename\n    identifyingName\n    employee {\n      name\n      id\n    }\n  }\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment TodoCircleStatusWithResponse_todo on Todo {\n  id\n  expireAt\n  status\n  canChangeStatus\n  canWrite\n  ordinal\n  isResponseCompleted\n  response {\n    __typename\n    ... on TodoResponseNumber {\n      __typename\n    }\n    ... on TodoResponseImage {\n      __typename\n      images {\n        id\n        ...Image_image\n      }\n    }\n    ... on TodoResponseText {\n      __typename\n    }\n  }\n}\n\nfragment TodoListItemAssignedUsers_todo on Todo {\n  assigned {\n    assignedAt\n    employee {\n      id\n      ...ListItemAssignees_employees\n    }\n    id\n  }\n  assignedRoles {\n    role {\n      id\n      ...ListItemAssignees_roles\n    }\n    id\n  }\n}\n\nfragment TodoListItemCompletedInfo_todo on Todo {\n  resolvedAtDate {\n    ...StoreFormattedDate\n  }\n  lastChangedStatusByActor {\n    __typename\n    ...Avatar_actor\n  }\n}\n\nfragment TodoListItemContact_todo on Todo {\n  contact {\n    name\n    phoneNumber\n    email\n  }\n  feedbackStatus\n}\n\nfragment TodoListItemFooterDone_todo on Todo {\n  ...TodoListItemContact_todo\n  feedbackStatus\n  contact {\n    __typename\n  }\n}\n\nfragment TodoListItemFooterPending_todo on Todo {\n  ...TodoListItemAssignedUsers_todo\n  ...TodoListItemContact_todo\n  feedbackStatus\n  contact {\n    __typename\n  }\n  expireAtDate {\n    ...StoreFormattedDate\n    isoString\n  }\n  tags {\n    ...TodoListItemTags_tag\n  }\n  assigned {\n    __typename\n    id\n  }\n  assignedRoles {\n    __typename\n    id\n  }\n  linkedProducts {\n    ...TodoListItemProducts_StoreProduct\n    id\n  }\n  ...TodoListItemFooterSubTodos_todo\n  subTodos {\n    __typename\n    id\n  }\n  commentCount\n}\n\nfragment TodoListItemFooterSubTodos_todo on Todo {\n  id\n  subTodos {\n    status\n    id\n  }\n}\n\nfragment TodoListItemFooter_todo on Todo {\n  ...TodoListItemFooterDone_todo\n  ...TodoListItemFooterPending_todo\n  status\n}\n\nfragment TodoListItemHeaderWrapper_todo on Todo {\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n  timeToResolvedFormatted\n}\n\nfragment TodoListItemHeader_todo on Todo {\n  ...TodoListItemHeaderWrapper_todo\n  subject {\n    ...TodoSubject_TodoSubject\n  }\n  title\n  isIssue\n  createdByActor {\n    __typename\n    ...CreatedBySubject_actor\n  }\n}\n\nfragment TodoListItemMainContentDetails_todo on Todo {\n  ...TodoListItemCompletedInfo_todo\n  status\n  images {\n    id\n    ...Image_image\n  }\n  linkedProducts {\n    imageUrl\n    id\n  }\n}\n\nfragment TodoListItemMainContentText_todo on Todo {\n  title\n  isIssue\n  status\n}\n\nfragment TodoListItemPriority_todo on Todo {\n  priority\n  status\n}\n\nfragment TodoListItemProducts_StoreProduct on StoreProduct {\n  name\n}\n\nfragment TodoListItemTags_tag on TodoCategoryTag {\n  id\n  color\n  title\n}\n\nfragment TodoListItem_todo on Todo {\n  id\n  status\n  ordinal\n  response {\n    __typename\n  }\n  canWrite\n  isOrg\n  body\n  formattedBody\n  canChangeStatus\n  ...TodoListItemMainContentText_todo\n  ...TodoListItemPriority_todo\n  ...TodoListItemFooter_todo\n  ...TodoCircleStatusWithResponse_todo\n  ...TodoListItemMainContentDetails_todo\n  ...TodoListItemHeader_todo\n}\n\nfragment TodoSubjectIcon_TodoSubject on TodoSubject {\n  icon\n  iconUri\n}\n\nfragment TodoSubject_TodoSubject on TodoSubject {\n  allBreadcrumbs {\n    title\n    requiredToDescribeTodo\n  }\n  ...TodoSubjectIcon_TodoSubject\n}\n"
  }
};
})();

(node as any).hash = "ae75a2af633617b0f1382438ff103e56";

export default node;
